enum TransactionResult {
  None = 0,
  Approved = 1,
  PartiallyApproved = 2,
  Declined = 3,
  OfflineApproved = 4,
}

export { TransactionResult };
